<div class="signal-card__badge-col">
	<div
		class="signal-badge"
		[class.signal-badge--high]="signal.severity === 'high'"
		[class.signal-badge--medium]="signal.severity === 'medium'"
		[class.signal-badge--low]="signal.severity === 'low'"
	>
		<div class="signal-badge__dot"></div>
		<typography variant="p/xxs_semibold" class="signal-badge__label">
			{{ signal.severity | titlecase }}
		</typography>
	</div>
</div>

<div class="signal-card__content">
	<typography variant="p/base_semibold" class="signal-card__title">
		{{ signal.title }}
	</typography>
	<typography variant="p/base_regular" class="signal-card__description">
		{{ signal.description }}
	</typography>
	<typography variant="p/xxs_regular" class="signal-card__source">
		Source: {{ sourceLabel }}
	</typography>
</div>
